import styled from 'styled-components';

export const MyEbonsPageContainer = styled.main`
    &#p-my-ebons {
        margin-bottom: 60px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/reminder/MyEbonsPageStyle.js